import { FilterIcon, SearchIcon } from "@heroicons/react/outline";
import { ChevronLeftIcon } from "@heroicons/react/solid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getStudents } from "../../../api/mock/data/students";
import Pagination from "../../../components/pagination/Pagination";
import { indexStudents } from "../../../api/endpoints/tutors/students";
import StudentModel from "../../../api/models/StudentModel";
import PlaceHolder from "../../../components/placeHolder.tsx/PlaceHolder";
import { showApiErrorMessages } from "../../../helpers";
import TelawahModel from "../../../api/models/TelawahModel";
import DropDown from "../../../components/forms/dropdown/DropDown";
import AppFilters from "../../../components/app-filters/AppFilters";
import ShowIf from "../../../components/show-if/ShowIf";
import { ApiCommonParams } from "../../../api/@types/apiTypes";
import { ReadersTable } from "./ReadersTable";
import { useQuery } from "react-query";
import { useTelawah } from "../../../hooks/useTelawah";

export default function ReadersView() {
  const LocalBasePath = "page.tutor.dashboard.readers";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [showFilters, setShowFilters] = useState(false);
  const { telawahs, telawahOptions, telawahsObject } = useTelawah();
  const [filters, setFilters] = useState<{ [key: string]: any }>({});
  const [currentPage, setCurrentPage] = useState(1);
  const resetCurrentPage = () => {
    setCurrentPage(1);
  };

  const { data: students } = useQuery(
    ["tutorStudents", currentPage, filters],
    () => {
      let apiParams: ApiCommonParams = {
        filters,
        pagination: { pageSize: 10, pageNumber: currentPage },
      };
      return indexStudents(apiParams);
    },
    {
      keepPreviousData: true,
      select: (response) => {
        let fetchedStudents: StudentModel[] = [];
        if (response.isSuccess) {
          fetchedStudents = StudentModel.fromApiResponse(response.data);
        } else {
          showApiErrorMessages(response);
        }
        const paginationInfo = response.pagination;
        return { data: fetchedStudents, paginationInfo };
      },
    }
  );

  useEffect(() => {
    resetCurrentPage();
  }, [filters]);

  const onCancelFilters = () => {
    setShowFilters(false);
    setFilters({});
  };

  return (
    <div className="w-full flex flex-col justify-between">
      <div
        className={`flex flex-col h-full min-w-full w-fit ${
          !!students?.data && students.data.length > 0 && " ring-gray-300"
        }`}
      >
        <div className="bg-gray-50 p-4 divide-gray-300 text-gray-900 flex items-center justify-between">
          <h2 className="text-2xl">{t("readers")}</h2>
          <button
            data-cy="filter"
            type="button"
            onClick={() => setShowFilters((x) => !x)}
            className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
          >
            <div className="flex items-center justify-start gap-2">
              <FilterIcon className="h-5 w-5" aria-hidden="true" />
              {t("filter")}
            </div>
          </button>
        </div>
        {/* <div className="mt-1 relative rounded-md shadow-sm mx-4">
                <div className="absolute inset-y-0 start-0 ps-3  flex items-center pointer-events-none">
                  <SearchIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </div>
                <input
                  type="text"
                  name="serarch"
                  id="serarch"
                  className="focus:ring-brandblue-500 focus:border-brandblue-500 block w-full ps-10  sm:text-sm border-gray-300 rounded-md"
                  placeholder={t("search")}
                />
              </div> */}
        <ShowIf condition={showFilters}>
          <AppFilters
            className="pt-1 pb-5 flex gap-4 bg-gray-50 px-4"
            filters={filters}
            onLoadMore={(key: string) => {}}
            setFilters={setFilters}
            fields={[
              {
                name: "telawah_id",
                label: t("recitation"),
                options: telawahOptions || [],
              },
            ]}
            handleButtonClick={onCancelFilters}
          />
        </ShowIf>
        <div className="w-full h-px bg-gray-200" />
        {!!students?.data && students.data.length > 0 ? (
          <>
            <ReadersTable
              readers={students.data}
              telawahs={telawahsObject || {}}
            />
            <div className="sticky bottom-0 mt-10 ">
              <Pagination
                hasNext={!!students.paginationInfo?.hasNext}
                hasPrev={!!students.paginationInfo?.hasPrev}
                goToPage={(page: number) => setCurrentPage(page)}
                currentPage={students.paginationInfo?.currentPageNumber!}
                numberOfPages={students.paginationInfo?.pagesCount!}
              />
            </div>
          </>
        ) : (
          <div className="w-full h-full flex justify-center items-center">
            <PlaceHolder title="noReadersTitle" />
          </div>
        )}
      </div>
    </div>
  );
}
